import { render } from "./Concept_en_m.vue?vue&type=template&id=8a6e671e"
import script from "./Concept_en_m.vue?vue&type=script&lang=js"
export * from "./Concept_en_m.vue?vue&type=script&lang=js"
script.render = render

export default script